import { useState } from 'react';

export const useTrashDeleteExpense = (deleteExpense) => {
  const [isTrashDragOver, setIsTrashDragOver] = useState(false);

  const handleTrashDragOver = (e) => {
    e.preventDefault();
    setIsTrashDragOver(true);
  };
  const handleTrashDragLeave = () => setIsTrashDragOver(false);
  const handleTrashDrop = (e) => {
    e.preventDefault();
    setIsTrashDragOver(false);
    try {
      const json = e.dataTransfer.getData('application/json');
      if (!json) return;
      const expense = JSON.parse(json);
      if (expense?.checksum) {
        deleteExpense(expense.checksum);
      }
    } catch {
      // silent
    }
  };

  return { isTrashDragOver, handleTrashDragOver, handleTrashDragLeave, handleTrashDrop };
};